import { REQUESTDOMAIN, KEY, curServerHost, project, DEVICEID } from 'CONFIG/config';
import apiRequest from 'UTILS/apiRequest';

const firstWordUpperCase = (string) => string[0].toUpperCase() + string.substring(1);

/**
 * 注册函数
 * @param {*} fileName 文件名
 * @param {*} apiName api方法名
 * @param {*} data 入参
 * @param {*} opt 覆盖配置
 */
export const createApiOpt = (fileName, apiName, data = {}, opt = null) => {
  let params = {
    url: `${REQUESTDOMAIN}/proxymsg`,
    reqDesction: `${apiName}Req`,
    resDesction: `${apiName}Res`,
    funcName: `${apiName}`,
    token: KEY,
    deviceid: DEVICEID,
    serverName: `mizhua.${fileName}.${firstWordUpperCase(fileName)}ExtObj`,
    application: project,
    data
  };

  params = opt !== null ? Object.assign(params, opt) : params;

  const serverName = params.serverName;
  const index = serverName.indexOf('.');
  params['serverName'] = (curServerHost || 'mizhua') + serverName.substring(index);
  return apiRequest(params);
};
